import React, { useEffect,useState } from 'react';
import Navbar from '../components/Navbar';
import WindowManager from '../components/WindowManager';
import { useIsDesktop } from '../contexts/useScreenSize';
import AndroidNavbar from '../components/AndroidNavbar'; // Nova Navbar para Android
import { PrintProvider } from '../contexts/PrintContext';
import jsPDF from 'jspdf';
import { Capacitor } from '@capacitor/core';
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { FileOpener } from '@capawesome-team/capacitor-file-opener';
import { useWindowManager } from '../contexts/WindowManagerContext';
import autoTable from 'jspdf-autotable';
import db from '../services/db';
import { useParams } from 'react-router-dom';
import { Browser } from '@capacitor/browser';
import { Share } from '@capacitor/share';

function HomePagePrint() {





   const {
      windows,
      openWindow,
      minimizeWindow,
      restoreWindow,
      minimizeAllWindows,
      restoreAllWindows,
      updateWindowPosition,
      focusedWindow,
      setFocusedWindow,
    } = useWindowManager();
  const [base64, setBase64pdf] = useState('');
  const { id } = useParams();
  
  useEffect(() => {
    const fetchPedido = async () => { 
      console.log('ent')
      try {
   

        const storedUser = await db.currentUser.get('currentUser');
        const vendedor = await db.vendedorModel.get(storedUser.vendedorModelId);
        // Busca o pedido pelo ID
        const pedido = await db.pedidos.get(Number(98526));
       

        console.log('Pedido encontrado:', pedido);

        // Resolver cliente e outros dados relacionados usando os IDs corretos
        const cliente = pedido.idCliente ? await db.clientes.get(Number(pedido.idCliente)) : null;
      
        const condicaoPagamento = pedido.idCondicaoPagamento
          ? await db.condicaoPagamento
            .where('idCondicaoPagamento')
            .equals(pedido.idCondicaoPagamento)
            .first()
          : null;
        const naturezaOperacao = pedido.idNaturezaOperacao
          ? await db.tiposOperacao
            .where('idNaturezaOperacao')
            .equals(pedido.idNaturezaOperacao)
            .first()
          : null;
        const formaPagto = pedido.idFormaPagamento
          ? await db.formasPagamentos.get(Number(pedido.idFormaPagamento))
          : null;
        // Se estiver duplicando, gerar novas parcelas

        // Transformar os itens para o modelo usado na tela de Itens
        const itensFormatados = (pedido.itens || []).map((item) => ({
          idProduto: item.idProduto,
          descricao: item.nomeProduto,
          codigoProduto: item.codigoProduto || null, // Garante que o código do produto esteja presente
          quantidade: item.quantidade || 0, // Garante que a quantidade seja pelo menos 0
          preco: item.valorUnitario || 0, // Define o preço unitário
          total: item.valorTotal || item.quantidade * (item.valorUnitario || 0), // Calcula o total caso não esteja definido
        }));

        console.log('Itens formatados:', itensFormatados);

        let novasParcelas = [];
        if ( condicaoPagamento) {
          const dias = condicaoPagamento.dias
            ? condicaoPagamento.dias.split(',').map((dia) => parseInt(dia.trim(), 10))
            : [];
          const enableParcelas = dias.length > 0;
          if (enableParcelas) {
            const valorTotal = itensFormatados.reduce((acc, item) => acc + item.total, 0);
            const parcelaValor = (valorTotal / dias.length);
            novasParcelas = dias.map((dia, index) => ({
              numero: index + 1,
             
              valor: parcelaValor,
            }));
          }
        }


      
        console.log(pedido.idPedido)
        console.log(pedido.idLocal)
        // Configuração do estado com dados resolvidos
        printPDF({
          idPedido: ( pedido.idPedido),
          idLocal: ( pedido.idLocal),
        
          sincronismo: pedido.sincronismo || false,
          dadosGerais: {
            numeroPedido:pedido.numeroPedido,
            cliente: cliente || null,
            naturezaOperacao: naturezaOperacao || null,
            formaPagamento: formaPagto || null,
            condicaoPagamento: condicaoPagamento || null,
            ramoAtividade: cliente?.ramoAtividade || null,
            vendedor: vendedor.nome || '',
          },
          itens: itensFormatados,
          frete: {
            valorFrete: pedido.valorFrete || 0,
            transportadora: pedido.transportadora || null, // Ajuste conforme necessário
          },
          parcelas:  pedido.parcelas || [],
        
        },null);
      
      } catch (error) {
       
      }
    };

 
      fetchPedido();
   
  }, [id]);
  
  const isDesktopLike = useIsDesktop(1024);

  const printPDF = async (pedidoData, showNotification) => {


    
    try {
      const doc = new jsPDF({ format: 'a4', unit: 'pt' });
      
      // Cabeçalho
      doc.setFontSize(14);
      doc.text('Pedido de Venda', 40, 40);
      
      // Dados do Cliente
      let yPos = 80;
      doc.setFontSize(10);
      doc.text(`Cliente: ${pedidoData.dadosGerais?.cliente?.nome || '-'}`, 40, yPos);
      yPos += 14;
      doc.text(`Endereço: ${pedidoData.dadosGerais?.cliente?.endereco || '-'}`, 40, yPos);
      yPos += 14;
      doc.text(
        `Cidade/UF: ${pedidoData.dadosGerais?.cliente?.cidade || '-'} / ${pedidoData.dadosGerais?.cliente?.estado || '-'}`,
        40,
        yPos
      );
      yPos += 14;
      doc.text(`Telefone: ${pedidoData.dadosGerais?.cliente?.telefone || '-'}`, 40, yPos);
      yPos += 14;
      doc.text(`CNPJ/CPF: ${pedidoData.dadosGerais?.cliente?.documento || '-'}`, 40, yPos);
      yPos += 14;
      
      // Dados do Pedido
      yPos += 20;
      doc.setFontSize(12);
      doc.text('Informações do Pedido:', 40, yPos);
      yPos += 14;
      doc.setFontSize(10);
      doc.text(
        `Emissão: ${pedidoData.dataPedido ? new Date(pedidoData.dataPedido).toLocaleDateString() : '-'}`,
        40,
        yPos
      );
      yPos += 14;
      doc.text(`Número do Pedido: ${pedidoData.numeroPedido || '-'}`, 40, yPos);
      yPos += 14;
      doc.text(
        `Data de Entrega: ${pedidoData.dataEntrega ? new Date(pedidoData.dataEntrega).toLocaleDateString() : '-'}`,
        40,
        yPos
      );
      yPos += 14;
      doc.text(
        `Natureza da Operação: ${pedidoData.dadosGerais?.naturezaOperacao?.descricaoCompleta || '-'}`,
        40,
        yPos
      );
      yPos += 20;
      
      // Tabela de Itens usando autoTable
      const columns = [
        { header: 'Código', dataKey: 'codigoProduto' },
        { header: 'Descrição', dataKey: 'descricao' },
        { header: 'Qtd', dataKey: 'quantidade' },
        { header: 'Vlr Unit.', dataKey: 'preco' },
        { header: 'Vlr Total', dataKey: 'total' },
      ];
      const tableData = pedidoData.itens.map((item) => ({
        codigoProduto: item.codigoProduto || '-',
        descricao: item.descricao || '-',
        quantidade: item.quantidade || 0,
        preco: (item.preco || 0),
        total: (item.total || 0),
      }));
      
      autoTable(doc, {
        startY: yPos,
        head: [columns.map((col) => col.header)],
        body: tableData.map((row) => columns.map((col) => row[col.dataKey])),
        styles: { fontSize: 9, halign: 'left' },
        headStyles: { fillColor: [52, 73, 94] },
        theme: 'grid',
      });
      
      const finalY = doc.lastAutoTable.finalY + 20;
      doc.setFontSize(10);
      doc.text(`Valor Total dos Produtos: R$ ${pedidoData.valorTotalProdutos}`, 40, finalY);
      doc.text(
        `Descontos Totais: R$ ${pedidoData.descontosTotais ? pedidoData.descontosTotais : '0.00'}`,
        40,
        finalY + 14
      );
      doc.text(
        `Valor Total do Pedido: R$ ${pedidoData.valorTotalPedido ? pedidoData.valorTotalPedido : '0.00'}`,
        40,
        finalY + 28
      );
      doc.text(
        `Peso Total dos Produtos: ${pedidoData.pesoTotalProdutos ? pedidoData.pesoTotalProdutos : '0.00'} Kg`,
        40,
        finalY + 42
      );
      
      // Distinção entre ambiente nativo e web
     
        const pdfBase64 = doc.output('datauristring').split(',')[1];
        setBase64pdf(pdfBase64)

  
          await Browser.open({ url: `data:application/pdf;base64,${base64}`});
        
     //   console.log(pdfBase264)
      //  await InAppBrowser.openInExternalBrowser({
     //     url: pdfBase264
     //});

   //  await InAppBrowser.openInSystemBrowser({
 ///     url: "https://www.google.com",
//      options: DefaultSystemBrowserOptions
//  });
       /* const fileName = `pedido_${pedidoData.numeroPedido || Date.now()}.pdf`;
         // Extraia somente a parte base64 sem o prefixo
  
      // Salva o PDF no diretório Documents para que outros apps possam acessá-lo
      await Filesystem.writeFile({
        path: fileName,
        data: pdfBase64,
        directory: Directory.Documents,
        recursive: true,
      });

      const fileUriResult = await Filesystem.getUri({
        path: fileName,
        directory: Directory.Documents,
      });
      const fileUri = fileUriResult.uri;
      console.log('URI do PDF:', fileUri);

      // Compartilha o PDF usando a propriedade "files"
      await Share.share({
        title: 'Compartilhar PDF',
        text: 'Segue o PDF do pedido',
        files: [fileUri],
        dialogTitle: 'Compartilhar PDF',
      });
      /*  await Filesystem.writeFile({
          path: fileName,
          data: pdfBase64,
          directory: Directory.Cache,
          encoding: Encoding.UTF8,
        });
        
        const { uri } = await Filesystem.getUri({
          directory: Directory.Cache,
          path: fileName,
        });
        
        await FileOpener.open({
          filePath: uri,
          contentType: 'application/pdf',
        });*/
    //  } else {
    //    doc.save(`pedido_${pedidoData.numeroPedido || 'sem_numero'}.pdf`);
    //  }*/
    } catch (error) {
      console.error('Erro ao imprimir PDF:', error);
      if (showNotification) {
        showNotification('Houve um erro ao gerar o PDF. Tente novamente.');
      }
    }

  };
 
 
  return (
    <div>

      {base64}
    </div>
  );
}

export default HomePagePrint;